<template>
  <div>
     <v-parallax
      dark
      id="home"
      style="background-color: white; height: 100vh;"
    >
      <!-- homepage web -->
      <div class="text hidden-sm-and-down">
        <v-layout align-center row wrap justify-center>
          <v-flex xs5 sm5 md5 xl5 lg5 style="justify-content: right; display: grid;">
            <img src="/static/img/onechat/banner-homepage.jpg" style="height: 70vh;">
          </v-flex>
          <v-flex xs7 sm7 md7 xl7 lg7 style="margin-top: 4vh;">
            <v-layout align-center column justify-center wrap>
              <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                <img src="/static/img/icons/logoonechat_full.png" style="height: 100px; justify-content: right;">
            </v-flex>
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;color: black;">
                <h1>ร่วมเป็นส่วนหนึ่งกับพวกเรา One Chat</h1>
            </v-flex>
                <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                <v-btn class="buttonblue" @click="toPage('/register')">สมัครสมาชิก</v-btn>
                <v-btn class="buttonblue" @click="toPage('/download')">ดาวน์โหลด</v-btn>
              </v-flex>
          </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <!-- homepage mobile -->
      <div class="textmo hidden-md-and-up">
        <v-layout align-center column wrap justify-center>
          <v-flex xs12 sm12 >
            <v-layout align-center column justify-center>
              <img src="/static/img/onechat/banner-homepage.jpg" style="height: 30vh; justify-content: right;">
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 style="margin-top: 3vh;">
            <v-layout align-center column justify-center>
            <v-flex xs12 sm12 style="margin-top: 1vh; color: black;">
                <h3>ร่วมเป็นส่วนหนึ่งกับพวกเรา</h3>
            </v-flex>
          </v-layout>
          </v-flex>
          <v-flex xs12 sm12 style="margin-top: 1vh;" >
            <v-layout align-center row wrap justify-center>
              <v-btn   class="buttonblue" style="width: 40%;" @click="toPage('/register')">สมัครสมาชิก</v-btn>
              <v-btn  class="buttonblue" style="width: 40%;" @click="toPage('/download')">ดาวน์โหลด</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <!-- footer web-->
      <div class="footer hidden-sm-and-down">
        <v-layout align-center row justify-center>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a></b></p>
          <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>
          <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
        </v-layout>
      </div>
      <!-- footer mobile-->
      <div class="footer hidden-md-and-up">
        <v-layout align-center column justify-center v-if="snackbar === true" style="margin-bottom: 9vh;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
          </v-flex>
          <v-flex xs12 md12>
            <p style="padding-left: 20px; padding-right: 20px;color: black !important;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout>

        <v-layout align-center column justify-center v-else style="margin-bottom: 0vh;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black !important;" @click="toNewTab('https://chat-develop.one.th/docs')">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black !important;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md12>
            <p style="padding-left: 20px;color: black; padding-right: 20px;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout>
        <v-flex xs12 md12 style="background: #414141; margin: 0; bottom: 0px;position: fixed; width: 100%; height: 12vh; padding: 5px !important;" v-if="snackbar" class="CSChatThai">
          <v-layout align-center justify-center row fill-height>
            <v-flex xs2 md2>
              <v-btn icon flat  @click="closedownload()"><v-icon style="font-size: 18px !important;">close</v-icon></v-btn>
            </v-flex>
            <v-flex xs5 md5>
              {{ textsnackbar }}
            </v-flex>
            <v-flex xs5 md5>
              <v-btn color="info" @click="downloadios()" v-if="deviceos === 'ios'" drak>ดาวน์โหลด</v-btn>
            <v-btn color="info" @click="downloadandroid()" v-else drak>ดาวน์โหลด</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
    </v-parallax>
  </div>
</template>
<script>
export default {
  created () {
    // this.$router.push('/not_found')
    window.location.replace('onechat://com.oneplatform/xxxx')
    // if (this.$route.params.type === 'friend' || this.$route.params.type === 'group') {
    //   window.location.replace('onechat://com.oneplatform/qrcode/' + this.$route.params.type + '?id=' + this.$route.query.id)
    // } else {
    //   this.$router.push('/not_found')
    // }
  }
}
</script>
<style type="text/css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/redirecttest.vue